import firebase from 'firebase/app';
import 'firebase/functions';
export default {
	
	get(route, data = {}){
		let getData = firebase.functions().httpsCallable('hubspot');
		return getData({route: route, params: data}).then(res => {
			return res.data
		})
	},
	post(route, data = {}){
		let postData = firebase.functions().httpsCallable('hubspot');
		return postData({method: "POST", route: route, params: data}).then(res => {
			return res.data
		})
	}
}